import React from "react";
import { useTranslation } from "react-i18next";
import doneIcon from "../../assets/images/done-icon.png";
import RequestAcceptedPopupProps from "./RequestAcceptedPopupProps";
import "./RequestAcceptedPopup.scss";

const RequestAcceptedPopup = (props: RequestAcceptedPopupProps) => {
  const { t } = useTranslation("common");

  return (
    <div className="request-accepted-wrapper">
      <img src={doneIcon} alt="" />
      <span id="dialogTitle" className="request-accepted-first-label" >
        {props.mainLabel ? props.mainLabel : t("RequestAcceptedPopup.accepted")}
      </span>
      <span className="request-accepted-second-label">
        {props.secondLabel
          ? props.secondLabel
          : t("RequestAcceptedPopup.contact")}
      </span>
    </div>
  );
};

export default RequestAcceptedPopup;
